export default __webpack_public_path__ + "static/media/mpk_2.7f6b46fd.png";